// extracted by mini-css-extract-plugin
export default {"transactionUnderContract":"styles_transactionUnderContract__AxTWX","head":"styles_head__ib4MS"};